import baseStore from './baseStore'

const state = {
  ...baseStore.state,
  modelDisplayNames: ['tag', 'tags'],
  modelName: 'tag',
}

const mutations = {
  ...baseStore.mutations
}

const actions = {
  ...baseStore.actions
}

const getters = {
  ...baseStore.getters,
  categoryChoices: function (state){
    if (!state.fieldsReady) return []
    return state.availableFields.category.choices
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
